import React from "react";
import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import HomepageProfessionalPortfolioLanding from "pages/homepage-professional-portfolio-landing";
import BlogProfessionalInsightsThoughtLeadership from "pages/blog-professional-insights-thought-leadership";
import BlogDetail from "pages/blog-professional-insights-thought-leadership/BlogDetail";
import ProjectsPortfolioShowcaseCaseStudies from "pages/projects-portfolio-showcase-case-studies";
import ProjectDetail from "pages/projects-portfolio-showcase-case-studies/ProjectDetail";
import AboutProfessionalStoryExpertise from "pages/about-professional-story-expertise";
import ResumeComprehensiveProfessionalBackground from "pages/resume-comprehensive-professional-background";
import ResumeDetail from "pages/resume-comprehensive-professional-background/ResumeDetail";
import ContactMultipleConnectionPointsAvailability from "pages/contact-multiple-connection-points-availability";
import NotFound from "pages/NotFound";
import AdminDashboard from "pages/admin";
import PublicationDetail from "pages/publication/PublicationDetail";
import AwardDetail from "pages/award/AwardDetail";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<HomepageProfessionalPortfolioLanding />} />
          <Route
            path="/homepage-professional-portfolio-landing"
            element={<Navigate to="/" replace />}
          />
          <Route
            path="/blog"
            element={<BlogProfessionalInsightsThoughtLeadership />}
          />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route
            path="/projects"
            element={<ProjectsPortfolioShowcaseCaseStudies />}
          />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route
            path="/about"
            element={<AboutProfessionalStoryExpertise />}
          />
          <Route
            path="/resume"
            element={<ResumeComprehensiveProfessionalBackground />}
          />
          <Route path="/resume/:slug" element={<ResumeDetail />} />
          <Route
            path="/contact"
            element={<ContactMultipleConnectionPointsAvailability />}
          />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/:tab" element={<AdminDashboard />} />
          <Route path="/publication/:idSlug" element={<PublicationDetail />} />
          <Route path="/award/:idSlug" element={<AwardDetail />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
